'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var index$2 = require('../ui/Button/index.js');
var index$3 = require('../ui/Product/index.js');
var index$1 = require('../ui/Swatch/index.js');
var index = require('../ui/Default/index.js');
var OptionProvider = require('./OptionProvider.js');
var Option_module = require('./Option.module.css.js');
var uuid = require('uuid');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function Option(_ref) {
  let {
    name,
    type,
    option,
    component,
    isMaxLimit = false,
    isSelected,
    isDisabled,
    onSelect
  } = _ref;
  const [isFocused, setIsFocused] = React.useState(false);
  const [isHovered, setIsHovered] = React.useState(false);
  const elId = uuid.v4() + option.ariaLabel;
  const disabled = isDisabled || option.isDisabled || isMaxLimit && !isSelected;
  const handleChange = () => {
    onSelect(option);
  };
  const handleFocus = () => {
    setIsFocused(true);
  };
  const handleBlur = () => {
    setIsFocused(false);
  };
  const handleMouseEnter = () => {
    setIsHovered(true);
  };
  const handleMouseLeave = () => {
    setIsHovered(false);
  };
  const uiComponent = () => {
    if (!component) return /*#__PURE__*/React__default["default"].createElement(index.DefaultComponent, null);
    switch (component) {
      case 'image':
        return /*#__PURE__*/React__default["default"].createElement(index$3["default"], null);
      case 'button':
        return /*#__PURE__*/React__default["default"].createElement(index$2["default"], null);
      case 'swatch':
        return /*#__PURE__*/React__default["default"].createElement(index$1.Swatch, null);
      default:
        return component;
    }
  };
  return /*#__PURE__*/React__default["default"].createElement(OptionProvider.OptionProvider, {
    state: {
      option,
      isDisabled: disabled,
      isFocused,
      isSelected,
      isHovered
    }
  }, /*#__PURE__*/React__default["default"].createElement("div", null, /*#__PURE__*/React__default["default"].createElement("div", {
    className: Option_module["default"].inputWrapper
  }, /*#__PURE__*/React__default["default"].createElement("input", {
    name: name,
    type: type,
    id: elId,
    value: option.value,
    disabled: disabled,
    checked: isSelected,
    "aria-label": option.ariaLabel,
    onChange: handleChange,
    onFocus: handleFocus,
    onBlur: handleBlur
  })), /*#__PURE__*/React__default["default"].createElement("label", {
    htmlFor: elId
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    role: "presentation",
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave
  }, uiComponent()))));
}

exports.Option = Option;
